import React from "react"
import Heading from "../common/heading/Heading"
import "./about.css"
import { homeAbout } from "../../dummydata"
import Awrapper from "./Awrapper"
import { useNavigate } from "react-router-dom"

const AboutCard = () => {
  const navigate = useNavigate()
  return (
    <>
     <div style={{display:'flex', justifyContent:'center',alignItems:'center', paddingBottom:'1em',}}>
      <div className="twobutton">
              <button className="">
                <a
                  href="https://wa.me/8048026985?text=Hello! I would like to learn more about your services."
                  className="btn btn-custom btn-lg page-scroll"
                  target="_blank"
                  style={{ textDecoration: "none", cursor: "pointer", color: "inherit" }}
                  rel="noopener noreferrer"
                >
                  ENQUIRE NOW
                </a>{" "}
                <i className="fa fa-long-arrow-alt-right"></i>
              </button>
              <button
                onClick={() => navigate("/courses")}
                style={{ cursor: "pointer" }}
              >
                VIEW COURSE <i className="fa fa-long-arrow-alt-right"></i>
              </button>
            </div>
      </div>
    
      <section className='aboutHome'>
        
        <div className='container flexSB'>
          <div className='left row'>
            <img src='./images/about.webp' alt='' />
          </div>
         
          <div className='right row'>
            <Heading subtitle='LEARN ANYTHING' title='Benefits About Online Learning Expertise' />
            <div className='items'>
              {homeAbout.map((val) => {
                return (
                  <div className='item flexSB'>
                    <div className='img'>
                      <img src={val.cover} alt='' />
                    </div>
                    <div className='text'>
                      <h2>{val.title}</h2>
                      <p>{val.desc}</p>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
       
      </section>
     
      {/* <Awrapper /> */}
    </>
  )
}

export default AboutCard
